import axios from 'axios'
import moment from 'moment'
import { notificationSuccess, notificationDanger, notificationDangerCustomTime } from '../../../utils/customToastify'

import {
  ACTIVITIES_HISTORY,
  COMMENTS_HISTORY,
  SHARED_NOTES_HISTORY,
  TASKS_HISTORY,
} from '../../../constants/historyDetailsTabTypes'

import {
  CREATE_OUT_OF_BUSINESS,
  GET_ALL_REDFLAG,
  GET_REDFLAG,
  DELETE_REDFLAG,
  UPDATE_REDFLAG,
  CREATE_REDFLAG,
  GET_ALL_OUTOFBUISNESS,
  GET_CONTACT,
  GET_ALL_CONTACTS,
  DELETE_CONTACT,
  CREATE_CONTACT,
  RESET_CONTACT,
  GET_CONTACTS_DIVISIONS,
  GET_CONTACTS_ADDITIONAL,
  GET_COMPANY_TYPE_OPTIONS,
  GET_DIVISIONS_COMBINED,
  SET_LOADER,
  GET_DUPLICATED_CONTACTS,
  GET_CONTACT_DIVISION,
  GET_RELATED_ENTITIES,
  SET_RELATED_ENTITIES_LOADING,
  GET_HISTORY_DATA,
  GET_STATUS_CHANGES,
  LOADING_PERSONAL_NOTES,
  GET_PERSONAL_NOTES,
  GET_LESSEE,
  CLEAR_LESSEE,
  GET_ALL_LESSEE,
  CONTACT_LOADING,
  CLEAR_CONTACTS,
  CONTACT_ASSIGNED,
} from './types'

import { GET_ERRORS } from '../../../actions/types'
import { closeModal, setModal } from '../../../common/GlobalModal/redux/GlobalModalActions'
import { clearAllErrors, setCustomError } from '../../../actions/errorsActions'
import { INSURANCE } from '../../../constants/divisions'
import { BRANCH_MANAGER, MANAGER } from '../../../constants/permissions'
import { isContactAssignable } from '../utils'
import { createTasks } from '../../Task/Redux/taskActions'
import { OUT_GOING_CALL } from '../../../constants/activityTypes'
import { now } from '../../../utils/utcTime'
import { downloadFile } from '../../../utils/fileDownloadUtils'

export const contactLoading = (isLoading) => (dispatch) => {
  dispatch({ type: CONTACT_LOADING, payload: isLoading })
}

export const clearContacts = () => (dispatch) => {
  dispatch({ type: CLEAR_CONTACTS })
}

export const getContactDivision = (divisionId, contactId) => async (dispatch) => {
  try {
    const response = await axios.get(`/contact-divisions/${divisionId}/${contactId}`)
    if (response.status === 200) {
      dispatch({
        type: GET_CONTACT_DIVISION,
        payload: response.data,
      })
    }
  } catch (error) {
    throw new Error(error)
  }
}

export const unassignContacts = ({ divisionId, selectedRows }, options) => async (dispatch) => {
  if (!selectedRows.length) {
    notificationDanger('Please select contacts')
    return
  }

  const contactIds = selectedRows.map((row) => row.id).filter(Boolean)

  const response = await axios.post('/contacts/unassignContacts', { divisionId, contactIds }, options)

  if (response.status === 200) {
    const reFetchedContacts = await axios.get('/contacts', { params: { ...options } })
    dispatch({ type: GET_ALL_CONTACTS, payload: reFetchedContacts.data })
  }
}

export const updateContactDivision = (divisionId, contactId, data) => async (dispatch) => {
  try {
    dispatch(setLoader())
    const response = await axios.patch(`/contact-divisions/${divisionId}/${contactId}`, data)
    if (response.status === 200) {
      notificationSuccess(`Status Updated Successfully.`)
      dispatch({
        type: GET_CONTACT_DIVISION,
        payload: response.data,
      })
    }
  } catch (error) {
    throw new Error(error)
  }
}

export const setLoader = () => ({
  type: SET_LOADER,
})

export const getLegalData = (options) => async (dispatch) => {
  dispatch(setLoader())
  const response = await axios.get(`/contacts/legal-data`, {
    params: { ...options },
  })
  dispatch(setLoader())
  return response
}

export const getContact = (contactId, divisionId) => async (dispatch) => {
  try {
    dispatch(contactLoading(true))
    const response = await axios.get(`/contacts/${contactId}`, { params: { divisionId } })
    dispatch({
      type: GET_CONTACT,
      payload: response.data,
    })
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    throw new Error(error)
  } finally {
    dispatch(contactLoading(false))
  }
}

export const getContactDataFromOldCrm = (contactId) => async (dispatch, getState) => {
  const contact = getState().contacts.contact
  const response = await axios.get('/contacts/contact-data-old-crm', { params: { id: contactId } })
  if (response.status === 200) {
    dispatch({
      type: GET_CONTACT,
      payload: { ...contact, ...response.data },
    })
  }
}

export const setContact = (contact) => async (dispatch) => {
  dispatch({
    type: GET_CONTACT,
    payload: contact,
  })
}

export const getAllRedFlags = (id, options) => async (dispatch) => {
  try {
    const response = await axios.get(`/contacts/getAllRedFlags/${id}`, {
      params: { ...options },
    })
    dispatch({
      type: GET_ALL_REDFLAG,
      payload: response.data,
    })
  } catch (error) {
    throw new Error(error)
  }
}

export const getRedFlag = (redFlagId) => async (dispatch) => {
  try {
    const response = await axios.get(`/contacts/getRedFlag/${redFlagId}`)
    dispatch({
      type: GET_REDFLAG,
      payload: response.data,
    })
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    throw new Error(error)
  }
}

export const updateRedFlag = (regFlagId, data) => async (dispatch) => {
  try {
    const response = await axios.patch(`/contacts/updateRedFlag/${regFlagId}`, data)

    dispatch({
      type: UPDATE_REDFLAG,
      payload: response.data,
    })
    notificationSuccess(`Red Flag Updated Successfully.`)
    return response
  } catch (error) {
    dispatch({
      type: GET_ERRORS,
      payload: error, //.response.data
    })
  }
}

export const createOutOfBusiness = (data) => async (dispatch) => {
  try {
    const response = await axios.post(`/contacts/createOutOfBusiness`, data)
    dispatch({
      type: CREATE_OUT_OF_BUSINESS,
      payload: response.data,
    })
    return response
  } catch (error) {
    dispatch({
      type: GET_ERRORS,
      payload: error.response.data,
    })
  }
}

export const createRedFlag = (data) => async (dispatch) => {
  try {
    const response = await axios.post(`/contacts/createContactsRedFlags`, data)
    dispatch({
      type: CREATE_REDFLAG,
      payload: response.data,
    })
    return response
  } catch (error) {
    dispatch({
      type: GET_ERRORS,
      payload: error.response.data,
    })
  }
}

export const deleteRedFlag = (contactId, data) => async (dispatch) => {
  try {
    const response = await axios.delete(`/contacts/deleteRedFlag/${contactId}`, data)
    dispatch({
      type: DELETE_REDFLAG,
    })
    notificationDanger('You just deleted Red Flag!')
    return response
  } catch (error) {
    throw new Error(error)
  }
}

export const getAllOutOfBusiness = (id, options) => async (dispatch) => {
  try {
    const response = await axios.get(`/contacts/getAllOutOfBusiness/${id}`, {
      params: { ...options },
    })
    dispatch({
      type: GET_ALL_OUTOFBUISNESS,
      payload: response.data,
    })
  } catch (error) {
    throw new Error(error)
  }
}

export const getAllContacts = (options, url) => async (dispatch) => {
  let response = {}
  dispatch({
    type: SET_LOADER,
  })
  if (url) {
    // todo fix: remove pagination
    //! encoding options to url adds pagination to url.query
    // eslint-disable-next-line no-unused-vars
    const { pagination, sort, ...otherQueries } = url?.query
    response = await axios.get(url.url, {
      params: { ...options, sort: {}, query: otherQueries },
    })
  } else if (!url) {
    response = await axios.get('/contacts', { params: { ...options } })
  }
  dispatch({
    type: GET_ALL_CONTACTS,
    payload: response.data,
  })
}

export const downloadContacts = async ({ options, url, callback, fileName = '' }) => {
  const name = moment().format('YYYY-MM-DD') + '_' + (fileName ? fileName : 'Contacts')
  const normalizedOptions = { ...options, pagination: { first: 0, limit: 50000 } }

  downloadFile({
    url,
    options: normalizedOptions,
    type: options.exportType,
    name,
    callback,
  })
}

export const getAllWinAgainAndProspectContacts = (options) => async (dispatch) => {
  dispatch({
    type: SET_LOADER,
  })
  const response = await axios.get('/contacts/win-again-accounts-prospects', { params: { ...options } })
  dispatch({
    type: GET_ALL_CONTACTS,
    payload: response.data,
  })
}

export const getMyLeadsProspectsAccounts = (options, myFilters) => async (dispatch) => {
  dispatch({
    type: SET_LOADER,
  })
  const response = await axios.get('/contacts/get-leads-prospects-accounts', { params: { ...options, myFilters } })
  dispatch({
    type: GET_ALL_CONTACTS,
    payload: response.data,
  })
}

export const getUnassignedLeads = (options) => async (dispatch) => {
  dispatch({
    type: SET_LOADER,
  })
  const response = await axios.get('/contacts/get-unassigned-leads', { params: options })
  dispatch({
    type: GET_ALL_CONTACTS,
    payload: response.data,
  })
}

export const getPending = (options, myFilters) => async (dispatch) => {
  dispatch({
    type: SET_LOADER,
  })
  const response = await axios.get('/contacts/pending', { params: { ...options, myFilters } })
  dispatch({
    type: GET_ALL_CONTACTS,
    payload: response.data,
  })
}

export const getDivisionClaimedLeadsAccounts = (options, myFilters) => async (dispatch) => {
  dispatch({ type: SET_LOADER })

  const response = await axios.get('/contacts/get-division-claimed-leads-accounts', {
    params: { ...options, myFilters },
  })

  dispatch({
    type: GET_ALL_CONTACTS,
    payload: response.data,
  })
}

export const getDuplicatedContacts = (options) => async (dispatch) => {
  const response = await axios.get('/contacts/duplicatedContacts', {
    params: { ...options },
  })
  dispatch({
    type: GET_DUPLICATED_CONTACTS,
    payload: response.data,
  })
  return response.data
}

export const getContactsDivisions = (id) => async (dispatch) => {
  try {
    const response = await axios.get(`/contacts/contactsDivisions/${id}`)
    dispatch({
      type: GET_CONTACTS_DIVISIONS,
      payload: response.data,
    })
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    throw new Error(error)
  }
}

export const getRrg = () => async (dispatch, getState) => {
  const { contact, contactsDivisions } = getState().contacts
  const response = await axios.get(`/contacts/rrg/${contact.id}`)
  if (response.status === 200) {
    if (response.data && response.data.result && response.data.result[0]) {
      const newContactDivision = contactsDivisions.map((item) => {
        if (item === INSURANCE) {
          return {
            ...item,
            rrg: response.data.result[0].cig.insBound,
          }
        }
        return item
      })
      dispatch({
        type: GET_CONTACTS_DIVISIONS,
        payload: newContactDivision,
      })
    }
  }
}

export const updateContact = (contactId, divisionId, data) => async (dispatch) => {
  try {
    delete data.contactDivisionData
    delete data.creator
    delete data.lastUpdater
    delete data.stateData
    delete data.lesseeData
    delete data.cps
    delete data.funding
    delete data.smartboard
    delete data.lease
    delete data.truckRental
    delete data.truckSales
    delete data.finance
    delete data.insurance
    delete data.customerLogistic
    delete data.legalMsg
    await axios.patch(`/contacts/${contactId}`, data)
    notificationSuccess(`Contact changed successfully`)
    await dispatch(getContact(contactId, divisionId))
    dispatch(getContactDataFromOldCrm(contactId))
    dispatch(getContactsDivisions(contactId))
  } catch (error) {
    // notificationDanger(error.response.data.error)
    dispatch({
      type: GET_ERRORS,
      payload: error?.response?.data || '',
    })
  }
}

export const createContact = (data) => async (dispatch) => {
  try {
    const response = await axios.post(`/contacts`, data)
    dispatch({
      type: CREATE_CONTACT,
      payload: response.data,
    })
    return response.data
  } catch (error) {
    dispatch({
      type: GET_ERRORS,
      payload: error.response.data,
    })
  }
}

export const deleteContact = (contactId, data) => async (dispatch) => {
  try {
    const response = await axios.delete(`/contacts/${contactId}`, data)
    dispatch({
      type: DELETE_CONTACT,
    })
    notificationDanger('You just deleted Contact!')
    return response
  } catch (error) {
    throw new Error(error)
  }
}

export const deleteContacts = (contactIds, callback) => async () => {
  try {
    await axios.delete('/contacts/multiple', { params: { ids: contactIds } })

    if (typeof callback === 'function') {
      callback()
    }
  } catch (error) {
    //
  }
}

export const resetContact = () => async (dispatch) => {
  try {
    dispatch({
      type: RESET_CONTACT,
      payload: {},
    })
  } catch (error) {
    throw new Error(error)
  }
}

export const getContactAdditional = (contactId) => async (dispatch) => {
  const response = await axios.get(`/contactsAdditional/contact/${contactId}`)
  dispatch({
    type: GET_CONTACTS_ADDITIONAL,
    payload: response.data,
  })
  if (response.status === 200) {
    return response.data
  }
}

export const updateContactAdditional = (id, data, contactId) => async (dispatch) => {
  await axios.patch(`/contactsAdditional/${id}`, data)
  await dispatch(getContactAdditional(contactId))
  notificationSuccess(`Contact Additional updated.`)
}

// Vraca da li je upis uspeo, da pozivalac moze da zatvori modal samo pri uspehu.
// Greska mora u catch: axios odbacuje promise na 4xx/5xx, pa se do else grane
// nikad nije stizalo - poruka o gresci se nije prikazivala, a izuzetak je isao dalje.
export const createContactAdditional = (data, contactId) => async (dispatch) => {
  try {
    await axios.post(`/contactsAdditional`, data)
    await dispatch(getContactAdditional(contactId))
    notificationSuccess(`Contact Additional created.`)
    return true
  } catch (error) {
    notificationDanger('Contact Additional creation failed.')
    return false
  }
}

export const deleteContactAdditional = (id, contactId) => async (dispatch) => {
  try {
    await axios.delete(`/contactsAdditional/${id}`)
    await dispatch(getContactAdditional(contactId))
    notificationDanger('You just deleted Additional Contact!')
  } catch (error) {
    throw new Error(error)
  }
}

export const assignWithTask = (selectedRows, callback, isMasterData, isToReassign) => async (dispatch, getState) => {
  try {
    console.log(selectedRows)
    const state = getState()
    const assignedByName = state.auth.user.name
    const { permissions = [], userId } = state.auth.user
    const myTeam = state.users.myTeam.map((user) => user.id)
    const isManagerOrBranchManager = permissions.includes(MANAGER) || permissions.includes(BRANCH_MANAGER)

    const contactIds = selectedRows.map((row) => (isMasterData ? row.contactId : row.id || row.contact?.id))
    const isAssignWithTaskDisabled =
      !isManagerOrBranchManager &&
      selectedRows.some(
        (row) =>
          !isContactAssignable(row?.users?.id, myTeam, {
            isAssignable: !!isToReassign,
            currentUserId: userId,
            canAssignTeam: isManagerOrBranchManager,
          })
      )

    const taskData = {
      description: `<p>This contact was assigned to you by ${assignedByName}</p>`,
      title: `Please Contact`,
      selectedActivityType: OUT_GOING_CALL,
    }

    const assignCallback = (isSuccess) => {
      if (isSuccess) {
        dispatch(createTasks(contactIds, callback))
      }
    }

    dispatch(
      setModal({
        id: 'task_modal',
        name: `Create Tasks`,
        setGlobalModalOverBootstrapModal: true,
        props: {
          contactIdTask: null,
          customData: taskData,
          assignCallback,
          isBatchCreation: true,
          isAssignWithTaskDisabled,
        },
      })
    )
  } catch (e) {
    //
  }
}

const contactsAssigned = (contactIds) => (dispatch) => {
  dispatch({ type: CONTACT_ASSIGNED, payload: contactIds })
}

export const assignUser = (assigned, selectedRows, isMasterDataAssign) => async (dispatch, getState) => {
  const state = getState()
  const divisionId = state.auth.user.division_id

  //! division claimed leads table => row.contact.id
  const contactIdsForUpdate = selectedRows.map((row) => {
    return isMasterDataAssign ? row.contactId : row.id || row.contact?.id
  })

  if (!contactIdsForUpdate.length) {
    notificationDanger('Please Select Contact')
    return
  }
  const response = await axios.post('/contacts/assignUser', {
    model: { assigned, cscCreationDate: now() },
    ids: contactIdsForUpdate,
    divisionId,
    isMasterDataAssign,
  })
  const { data } = response

  if (data === true || data === false) {
    dispatch(
      contactsAssigned(selectedRows.map((row) => (isMasterDataAssign ? row.contactId : row.id || row.contact?.id)))
    )
  }

  notificationSuccess(data ? 'Contacts Assigned' : 'Contact Assigned')
}

export const getOptions = () => async (dispatch) => {
  const response = await axios('/support-types/1')
  dispatch({
    type: GET_COMPANY_TYPE_OPTIONS,
    payload: response.data,
  })
}

export const getDivisions = (contactFirst, contactSecond) => async (dispatch) => {
  const response = await axios(`/contacts/getDivisions/?contactId=${contactFirst}&contactId=${contactSecond}`)
  dispatch({
    type: GET_DIVISIONS_COMBINED,
    payload: response.data,
  })
}

export const combineContacts = (data) => async () => {
  await axios.post('/contacts/combineContacts', data)
}

export const getRelatedEntities = (contactId, options) => async (dispatch) => {
  try {
    dispatch({ type: SET_RELATED_ENTITIES_LOADING })
    const response = await axios.get(`/contacts/related-entities`, {
      params: { contactId, ...options },
    })
    dispatch({
      type: GET_RELATED_ENTITIES,
      payload: response.data,
    })
  } catch {
    dispatch({ type: SET_RELATED_ENTITIES_LOADING })
  }
}

// LESSEE
export const findLesseeByMC = (mcNumber, noDispatch) => async (dispatch) => {
  const response = await axios.get(`/contacts/lessee/${mcNumber}`)
  if (!noDispatch) {
    dispatch({
      type: GET_LESSEE,
      payload: response.data,
    })
  } else {
    return response.data
  }
}

export const getAllLessee = (options) => async (dispatch) => {
  const response = await axios.get('/contacts/all-lessee', { params: options })
  dispatch({
    type: GET_ALL_LESSEE,
    payload: response.data,
  })
}

export const createLessee = (data, options, toggleModal) => async (dispatch) => {
  const hasLessee = await dispatch(findLesseeByMC(data.mcNumber, true))
  if (Object.keys(hasLessee || {}).length) {
    dispatch(setCustomError('mcNumber', 'Contact with that MC Number already exists!'))
  } else {
    const response = await axios.post(`/contacts/create/lessee`, data)
    toggleModal()
    await dispatch(getAllLessee({ ...options, tableFilter: { id: response.data[0].id } }))
  }
}

export const clearLessee = () => (dispatch) => {
  dispatch({
    type: CLEAR_LESSEE,
  })
}

/**
 * @PARAMS type
 * 1 => Activities
 * 2 => Shared Notes
 * 3 => Comments
 * 4 => Tasks
 * */

export const getHistoryData = (contactId, type, options) => async (dispatch) => {
  dispatch(setLoader())
  let response
  if (type === ACTIVITIES_HISTORY) {
    response = await axios.get(`/activity/activities-by-contact/${contactId}`, { params: options })
  } else if (type === SHARED_NOTES_HISTORY) {
    response = await axios.get(`/activity/shared-notes-by-contact/${contactId}`)
  } else if (type === COMMENTS_HISTORY) {
    response = await axios.get(`/comments/by-contact/${contactId}`)
  } else if (type === TASKS_HISTORY) {
    response = await axios.get(`/task/tasks-by-contact/${contactId}`)
  }
  if (response && response.status === 200) {
    dispatch({
      type: GET_HISTORY_DATA,
      payload: response.data,
    })
  } else {
    dispatch(setLoader())
  }
}

export const clearHistoryData = () => (dispatch) => {
  dispatch({
    type: GET_HISTORY_DATA,
    payload: [],
  })
}

export const setDeadToMe = () => async (_dispatch, getState) => {
  const { userId, division_id } = getState().auth.user
  const { id } = getState().contacts.contact
  const { statusId } = getState().contacts?.contact?.contactDivisionData
  await axios.post('/contact-dead', { userId, contactId: id, divisionId: division_id, statusId })
  notificationSuccess('Successfuly marked as dead')
}

export const setNotQualifiedToMe = () => async (_dispatch, getState) => {
  const { userId, division_id } = getState().auth.user
  const { id } = getState().contacts.contact
  const { statusId } = getState().contacts?.contact?.contactDivisionData
  await axios.post('/contact-not-qualified', { userId, contactId: id, divisionId: division_id, statusId })
  notificationSuccess('Successfuly marked as not qualified')
}

export const openIGiveUp = () => async (dispatch, getState) => {
  const { userId } = getState().auth.user
  const { id } = getState().contacts.contact
  const { statusId } = getState().contacts?.contact?.contactDivisionData
  const responseAttempts = await axios.get(`/activity/get-call-attempts`, {
    params: { userId, contactId: id, statusId },
  })
  const responseSystemMinCallAttempts = await axios.get('/system-config/get-columns', {
    params: { divisionId: null, columns: ['min_call_attempts'] },
  })
  if (responseAttempts.data >= responseSystemMinCallAttempts.data.minCallAttempts)
    dispatch(
      setModal({
        id: 'give_up',
        name: `Give Up On Contact?`,
        props: {},
      })
    )
  else
    notificationDangerCustomTime(
      `You have made ${responseAttempts.data} attempts and ${responseSystemMinCallAttempts.data.minCallAttempts} attempts are required before giving up`,
      10000
    )
}

export const setIGiveUp = (data, isNote) => async (dispatch, getState) => {
  dispatch(clearAllErrors())
  if (!data.giveUpReason) {
    dispatch(setCustomError('giveUpReason', 'Please select reason why you gave up!'))
    return
  } else if (isNote && !data.otherReasonNote) {
    dispatch(setCustomError('otherReasonNote', 'Please provide notes for why you gave up!'))
    return
  }
  const { division_id } = getState().auth.user
  const { id } = getState().contacts.contact
  const dataGiveUp = {
    ...data,
    divisionId: division_id,
    contactId: id,
  }
  await axios.post('/contact-give-up', dataGiveUp)
  dispatch(closeModal('give_up'))
  notificationSuccess('You have just gave up of this contact')
}

export const getStatusChanges = (options) => async (dispatch) => {
  const response = await axios.get('/contact-divisions/status-changes', { params: options })
  dispatch({
    type: GET_STATUS_CHANGES,
    payload: response.data,
  })
}

export const changeStatus = (data) => async () => {
  await axios.post('/contacts/status-change', data)
}

export const deleteBusinessCard = (documentKey) => async () => {
  await axios.delete('/contacts/delete-business-card', { params: { documentKey } })
}

// PERSONAL NOTES
export const createPersonalNote = (data, component) => async (dispatch) => {
  dispatch({ type: LOADING_PERSONAL_NOTES })
  await axios.post('/contact-personal-notes', data)
  if (component === 'contact') {
    dispatch(getContactPersonalNotes(data.contactId))
  } else if (component === 'add_contact') {
    //db typo [additionaContactId]
    dispatch(getAddContactPersonalNotes(data.additionaContactId))
  }
}

export const getContactPersonalNotes = (contactId) => async (dispatch) => {
  dispatch({ type: LOADING_PERSONAL_NOTES })
  const response = await axios.get(`/contact-personal-notes/contact/${contactId}`)
  dispatch({ type: GET_PERSONAL_NOTES, payload: response.data })
}

export const getAddContactPersonalNotes = (contactId) => async (dispatch) => {
  dispatch({ type: LOADING_PERSONAL_NOTES })
  const response = await axios.get(`/contact-personal-notes/add-contact/${contactId}`)
  dispatch({ type: GET_PERSONAL_NOTES, payload: response.data })
}

export const deletePersonalNote = (noteId, contactId, component) => async (dispatch) => {
  dispatch({ type: LOADING_PERSONAL_NOTES })
  await axios.delete(`/contact-personal-notes/${noteId}`)
  if (component === 'contact') {
    dispatch(getContactPersonalNotes(contactId))
  } else if (component === 'add_contact') {
    dispatch(getAddContactPersonalNotes(contactId))
  }
}

export const removeLesseeContact = (contactId, divisionId) => async (dispatch) => {
  try {
    dispatch(setLoader())

    await axios.delete(`/contacts/remove-lessee-contact/${contactId}`)
    await dispatch(getContact(contactId, divisionId))

    notificationSuccess('You have successfully removed the lessee contact.')
  } catch (error) {
    throw new Error(error)
  } finally {
    dispatch(setLoader())
  }
}
